<template>
<div class="h-100 w-100 p-relative">
  <swiper id="informationSwiper" :options="swiperOption" >
    <swiper-slide>
      <div class="pl-5">
        <h1 class="text-center">INFORMATION</h1>
        <p class="h5 text-center mt-4">【 LE SILLAGE / ル シヤージュ 】</p>
        <img class="img-fluid mt-5" src="@/assets/images/shop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <dl class="text-center">
        <dt class="font-weight-normal">
          OPEN
        </dt>
        <dd class="h4 mt-2">
          11:00~19:00
        </dd>
        <dt class="mt-4 font-weight-normal">
          CLOSE
        </dt>
        <dd class=" mt-2">
          <span class="h4">不定休</span><br>
          (店休日はSNS等で事前にお知らせ致します)
        </dd>
        <dt class="mt-4 font-weight-normal">
          TEL
        </dt>
        <dd class="h4 mt-2">
          075-752-2018
        </dd>
        <dt class="mt-4 font-weight-normal">
          MAIL
        </dt>
        <dd class=" mt-2">
          yonekura@lesillage-kyoto.com
        </dd>
      </dl>
    </swiper-slide>
    <swiper-slide>
      <dl class="text-center">
        <dt class="mt-4 font-weight-normal">
          ADDRESS
        </dt>
        <dd class=" mt-2">
          〒605-0034<br>
          京都市東山区中之町205-2 WILLPARK神宮 1F
        </dd>
        <dt class="mt-4 font-weight-normal">
          ACCESS
        </dt>
        <dd class=" mt-2">
          京都市営地下鉄東西線：蹴上駅or東山駅より徒歩5分<br>
          <br>
          京都市バス：神宮道駅より徒歩2分(5、46、100系統)<br>
          <br>
          京阪本線：三条京阪駅から徒歩13分
        </dd>
      </dl>

    </swiper-slide>
    <swiper-slide>
      <div class="w-100" style="height: 460px">
        <h6 class="text-center mb-4">MAP</h6>
        <b-embed
          type="iframe"
          aspect="1by1"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d478.95697633146597!2d135.78460616842028!3d35.00938172276057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600109ceb375a50f%3A0x1b49a73ef35e5111!2sLE%20SILLAGE%20FRAGRANCE%20SHOP%20KYOTO!5e0!3m2!1sja!2sjp!4v1605576277039!5m2!1sja!2sjp"
          allowfullscreen
        ></b-embed>
        <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d478.95697633146597!2d135.78460616842028!3d35.00938172276057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600109ceb375a50f%3A0x1b49a73ef35e5111!2sLE%20SILLAGE%20FRAGRANCE%20SHOP%20KYOTO!5e0!3m2!1sja!2sjp!4v1605576277039!5m2!1sja!2sjp" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
      </div>
    </swiper-slide>
    <swiper-slide>
      <dl class="text-center">
        <dt class="mt-4 font-weight-normal">
          RECRUIT
        </dt>
        <dd class=" mt-2">
          求人につきましての詳細<br>
          は<a class="text-dark underline" href="https://docs.google.com/forms/d/e/1FAIpQLSeT0j_KNGoYe_zqpcTZW8xofgpdY2oFu8-CeBj05thFnq6_VQ/viewform?usp=sf_link" target="_blank">お問い合わせフォーム</a>より<br>
          お問い合わせください。
        </dd>
      </dl>
    </swiper-slide>
  </swiper>
</div>

</template>

<script>
  export default {
    name: 'Information',
    data() {
      return {
        swiperOption: {
          direction: 'horizontal',
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 50,
          mousewheel: true,
        },
      }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
#informationSwiper {
  height: 100%;
  .swiper-slide {
    display: flex;
    align-items: center;
    width: 340px;
    margin-right: 50px;
    &.slider-item-brand {
      width: 340px;
    }
    &.slider-item-product {
      width: 464px;
    }
    &.slider-item-spacer {
      width: 200px;
      color: #fff;
    }
  }
}
</style>